export default {
    username: 'ID',
    password: 'パスワード',
    loginid: 'ID'
};
